import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20221104/1.jpg';
import image2 from '@/assets/images/news/detail/20221104/2.jpg';
import image3 from '@/assets/images/news/detail/20221104/3.jpg';
import image4 from '@/assets/images/news/detail/20221104/4.jpg';
import image5 from '@/assets/images/news/detail/20221104/5.jpg';

export default {
  id: '20221104', //  模块 id
  title: '叮咚买菜火锅料理师：食品工业催热火锅到家业务，宅家火锅也美味', // 标题
  origin: '2022-11-4 13:42:28 来源：每日商报', // 新闻来源
  editor: '编辑：沈艳', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '“醉鸡煲的鸡用的是清远走地鸡，鸡不能煮，要上汽蒸，这样才能保证它的鲜嫩；娘酒要在最后放，这样才能确保酒味儿挥发较少，充分锁进鸡汤里；通常一公斤水用7g盐最合适。”',
    },

    {
      type: NewsContentType.Text,
      text:
        '对这款醉鸡煲如数家珍的，是叮咚买菜的资深食品研发专家朱鹤，这是他今年研发出来的一款新品，顾客好评度极高。',
    },
    {
      type: 2,
    },   
    {
      type: NewsContentType.Text,
      text:
        '朱鹤是一名从业近20年的西餐厨师，曾任五星级酒店的行政副总厨。如今，他有了一个新的身份——火锅料理师。',
    },
    
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '图：叮咚买菜火锅料理师朱鹤在研发厨房。',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '近日，人社部发布《中华人民共和国职业分类大典（2022年版）》，“火锅料理师”成为中式烹调师职业下的新工种。根据官方定义，“火锅料理师”是从事火锅锅底、酱料、蘸料制作、菜肴预制、菜品切配并具备一定餐饮经营、管理能力的人员。',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '“火锅食材千千万，口味围绕锅底转”。生鲜电商叮咚买菜也在大力发展火锅业务，致力于将各地消费者喜欢的口味通过再次研发搬到叮咚买菜的平台上，送到全国各地的家庭餐桌上。和朱鹤一样，在叮咚买菜，从事火锅研发工作的专家一共有7位，他们主要负责叮咚大满冠的锅底和火锅食材的商品研发及应用，也就是当下被认证的新职业“火锅料理师”，叮咚买菜内部已对其进行授予。',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '在得知火锅料理师成为官方认证的新职业之后，叮咚买菜的另一位食品研发专家付安永也非常激动。“我是四川宜宾人，从小就爱吃火锅，火锅是咱们中国的特色，火锅料理师是一种职业荣誉感，感觉被认可、被尊重。”在付安永看来，火锅市场蓬勃向上，锅底的丰富的也在不断增加，随着火锅料理师的职业化，行业间的交流也会更多，会碰撞出更多的火花，能够一起推动整个火锅行业向前发展。“把火锅做好吃了，我们的火锅文化也能走向世界。”',
    },
    {
      type: 1,
      title: '',
      src: [image2],

    },
        {
      type: NewsContentType.Text,
      text:
        '图：叮咚买菜火锅料理师及团队',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '大厨转型火锅料理师：做好吃又方便的到家火锅',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '在来叮咚买菜之前，付安永和朱鹤几乎没有涉足过火锅行业，但他们都在餐饮行业摸爬滚打了20年，积累了丰富的烹饪经验和技巧，寻找美食、研究并做出来是他们最熟悉不过的工作。用付安永的话说：“不管是什么犄角旮旯的美食，循着味儿就去了，要是灶上坐着锅，鼻子远远一闻就知道味儿对不对。”',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '“味儿”也就是嗅觉和味觉的灵敏度，这也是付安永特别强调的。他认为，要成为一名合格的火锅料理师，就要保持味觉和嗅觉的灵敏度，从细微中辨别出差异，从而做到口味的一致性，因此他不抽烟、不喝酒，以此来保障味觉的敏感度。',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '在他看来，要做新品研发，基本功要扎实，脑子也要足够灵活。“200多种香辛料要认识、了解，鸡鸭鱼肉等菜品的各个部位辨别、刀工处理的技术。比如，餐馆里做翘脚牛肉，一定要顺着牛肉的纹理切，这样切出来的肉是整片的，好看、紧实又有韧劲。但是我们叮咚的翘脚牛肉因为要提前熟制，会经过冷冻、复热等环节，按照以往的做法，牛肉的水分不足，又干又柴，韧劲不够，在试验了很多次之后发现，问题出在了牛肉的切配方式上，逆着纹理切，牛肉的还原度更高。”',
    },
    {
      type: 1,
      title: '',
      src: [image3],

    },
        {
      type: NewsContentType.Text,
      text:
        '图：牛肉的切配方式也是一门学问',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '转型成为一名火锅料理师，对于西餐厨师出身的朱鹤来说，也是不小的挑战。“不管是在酒店还是在连锁西餐厅，我们要做的都是服务特定的消费者，但是在叮咚买菜，我们要服务上亿人次的消费者，众口难调，压力也会更大。”',
    },
    {
      type: 2,
    },      {
      type: NewsContentType.Text,
      text:
        '于是，朱鹤和他所在的叮咚买菜火锅料理师团队每年都会做详细的市场调研，看看全国各地的热门产品是什么，卖点是什么，再结合叮咚用户画像、口味偏好进行研发上架。比如，上海的用户喜欢吃猪肚鸡，北京的用户更偏爱冬天涮上一锅羊蝎子，成都的用户则喜欢肥肠鸡等重口味。今年，叮咚买菜推出了客家醉鸡煲、糟粕醋文昌鸡火锅、日式海鲜昆布火锅等餐饮市场上受关注度高的细分品类产品，希望消费者在家也能毫不费力地吃到最流行、最好吃的火锅。',
    },
    {
      type: 2,
    },     
    {
      type: NewsContentType.Text,
      text:
        '看数据而不是凭感觉，火锅料理师都是“细节控”',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '朱鹤和付安永都是经验老道的厨师，凭感觉随便一做，好吃的菜就出锅了。但做出100份、1000份符合大众口味的好吃、口味一致、出品标准的菜并非易事。规模化生产的要求，将最喜欢凭感觉，靠经验的厨师逼成了扣数据、看油温、计算水蒸发量的“细节控”。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '以朱鹤研发的广东特色醉鸡煲火锅为例，做一份醉鸡煲需要一只清远走地鸡，2公斤水，按照盐7g/公斤的比例调制口味，出汤量和盐度都刚刚好；但是规模化的出品需要大锅炖煮，高温炖煮水分蒸发也会变多，盐度也会有改变，因此加水量和放盐量需要重新调配，有时要精确到0.1g。        ',
    },
    {
      type: 1,
      title: '',
      src: [image4],

    },
        {
      type: NewsContentType.Text,
      text:
        '图：朱鹤在研发厨房调试醉鸡煲的配方',
    },
    {
      type: NewsContentType.Text,
      text:
        '在朱鹤看来，叮咚做火锅就是将最复杂的工作留给研发，到顾客手里只需要美味易上手。因此，他们不光要做好口味的研发，还要能够把握好食品工业的转化。用他的话说：“我们要把做菜的每一个步骤拆分成一个又一个的细节，将其量化、数据化，这样才能得到标准化、口味一致的产品。“蒸熟、炖煮之后，几百只鸡会混在一起，我们需要将鸡的各个部位重新分好、称好重量后组装起来，每个工人只负责一个细节，保证每一份都是半只鸡，重量也一样。”朱鹤坦言',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '在叮咚买菜平台上，好评度高达98.82%的肥肠鸡锅底也是这么来的。远在上海的付安永听说成都有家肥肠鸡，口味地道，周边居民赞不绝口，要提前几天预约才能吃到。为找到这道美味，他飞到成都沿着网友分享的路线，最终在当地人的指引下才找到了这家隐藏在居民楼里，连门脸儿都没有的小餐馆。后来，付安永在成都驻扎了几天，每日去店里和老板讨教，很快，这家苍蝇小馆里肥肠鸡的精髓学到了。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '调试出满意的口味只是第一步，要保证量产口味不变、冷冻锁鲜肉质不柴、复热时盐度、新鲜度在线，则相当困难。付安永将这道菜的每个烹饪环节拆分成一个又一个的小细节，盐度、辣度精确到的数值，肥肠、鸡腿肉各多少克，炖煮的火候要如何控制。“最开始挺难的，毕竟做了20年的中餐厨师，‘凭感觉’做菜的思维根深蒂固，我们现在要做的产品不光是口味好，还要有稳定的出品和简单的做法。只有这样，我们才能把更多的美味传递给我们的消费者。”',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '付安永尝试几十次之后，叮咚大满贯肥肠鸡锅底诞生了：“鲜嫩大块的鸡腿肉裹着红油，一点也不柴，肥肠处理的很干净，咬一口，香味一下子就在嘴里爆开，已经回购好几次了。”北京的消费者番美女士说。',
    },
    {
      type: 1,
      title: '',
      src: [image5],

    },
        {
      type: NewsContentType.Text,
      text:
        '图：叮咚大满冠肥肠鸡火锅',
    },
    {
      type: NewsContentType.Text,
      text:
        '新职业认证鼓舞火锅人，到家火锅成趋势',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '食材、锅底标准化程度高、已复制，连锁化程度仅次于西式快餐。最近几年，火锅行业蓬勃发展，市场规模不断提升。美团发布的《2022火锅行业市场洞察》报告显示，2021年中国火锅行业市场规模达到4998亿元，是中餐第一大细分品类。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '值得注意的是，疫情以来，餐饮行业洗牌加速，但火锅的行业地位仍不可撼动。随着市场和消费习惯的变化，火锅也呈现出主打细分品类、重视到家场景的新趋势。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '据了解，早在2015年，重庆市人社局就将火锅料理师作为地方特色工作进行认证，至今已有6万余人考核获得了重庆地方火锅专项职业能力证书。而此次，人社部宣布“火锅料理师”成为中式烹调师职业下的新工种，不仅是对火锅行业蓬勃发展的肯定，对于火锅行业及从业者而言，也是一种鼓舞。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '在四川人眼里，麻辣鲜香的红汤、铺满了蒜泥油碟是最勾人的家乡味道。在得知火锅料理师成为官方认证的新职业后，作为土生土长的四川人，付安永非常激动。“我们四川人，吃火锅儿长大的，这是我们四川的特色，也是咱们中国独有的美食文化，火锅料理师的称谓带给我一种职业荣誉感，感觉自己被认可、被尊重，我也为我的家乡感到骄傲。”',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '付安永还说，火锅市场蓬勃向上，锅底的丰富的也在不断增加，随着火锅料理师的职业化，行业间的交流也会更多，会碰撞出更多的火花，能够一起推动整个火锅行业向前发展。“把火锅做好吃了，我们的火锅文化也能走向世界。”',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '疫情之后，居家就餐成为新趋势，以往聚餐场景为主的火锅行业也开始掘金家庭市场。不光是海底捞、呷哺呷哺这样的传统餐饮企业将开始发力火锅外卖，以叮咚买菜为代表的生鲜电商新平台也非常看好这一市场。2021年年初起，叮咚买菜设立火锅业务部门，组建了一支30余人的团队，其中火锅调理师就有7位，在内部，统一称为研发专家，他们的主要的工作是负责叮咚大满冠的锅底和火锅食材的商品研发及应用。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '随着火锅料理师的加入，叮咚买菜的火锅到家业务发展迅速，火锅商品也越来越专业，商品种类日趋丰富的同时，还致力于为消费者提供专业的调配和吃法选择。2021年，叮咚买菜首次推出了行业最热的有料锅底，并且打造了“叮咚买菜，寻味中国火锅地图”的主题，集齐各地特色火锅菜。2022年，叮咚买菜与联手火锅餐饮，推出来餐饮联名火锅，以今年9月开启火锅季为例，重点打造了“养生派”火锅，推出了“番茄牛尾火锅”、“醉鸡煲火锅”、“当归羊肉火锅”等数十款创新锅底，既是火锅又是滋补汤品，将品质和健康放在首位。',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '得知“火锅料理师”成为中式烹调师职业下的新认证的工种后，叮咚买菜预制菜负责人欧厚喜也对未来充满了信心，她认为，新职业的认定代表着行业对于火锅全行业和火锅行业从业者的认可，“我们内部也会为公司的7名研发专家授予‘火锅料理师’荣誉，希望他们能够在火锅锅底、菜品研发、酱料、蘸料等产品的研发上能够有更多的新成绩。”',
    },
    {
      type: 2,
    },  
    {
      type: NewsContentType.Text,
      text:
        '此外，由于火锅跟其它预制菜不同，锅底的融合，及持续加热后的口感测试，包括火锅食材的涮煮等专业吃法及应用，这是其它研发不可替代的，“未来，叮咚买菜也不排除设有专职的火锅料理师。”欧厚喜畅想道。',
    },
    {
      type: 2,
    },  

  ],
};
